$(document).ready(function(){
  if($('body.product')){  
    const defaultNoticeInnerHTML = `<p class="customily_modal_preview--title">Please check the preview carefully</p> <p class="customily_modal_preview--notice_content"><em>Make sure the below customization is correct to receive your item faster</em></p>`
    
    function handleFakeBtnClick(t) {
      t.stopPropagation(),
        document.querySelector(".btn-preview-add-to-cart").classList.add("running");
      document.querySelector(".add_to_cart_js").click();
    }
    
    function mainFunc(item) {
      if (item.classList !== null && item.classList !== void 0) {
        if (item.classList.contains('canvas-container')) {
          let t = document.querySelector(".add_to_cart_js");
          let e = document.querySelector(".customily-modal-preview-only .main");
          
          let f = document.createElement('div');
          let g = document.createElement('button');

          g.innerHTML = 'Close';
          g.className = 'customily-close-btn';
    
          t.classList.add("btn-preview-add-to-cart");
          
          f.className = 'btn-wrapper';
          f.appendChild(t);
          f.appendChild(g);
          
          e.appendChild(f);
          t.addEventListener("click", function (t) {
            return handleFakeBtnClick(t);
          });
          g.addEventListener("click", function (t) {
            t.stopPropagation();
            t.preventDefault();
            // t.closest('.customily-modal-preview-only').find('.customily-close-button').click();
            document.querySelector(".customily-close-button").click();
          });
          const formWrapper = document.querySelector('.product_form');
          
          var modifyNoticeEl = document.createElement('div');
          modifyNoticeEl.className = 'customily_modal_preview--modify_notice';
          
          modifyNoticeEl.innerHTML = defaultNoticeInnerHTML;
          e.appendChild(modifyNoticeEl)
        }
      }
    }  
    (function () {
      try {
        const observer = new MutationObserver(function (t) {
          t.forEach(function (t) {
            if (t.addedNodes) {
              for (var r = 0; r < t.addedNodes.length; r++) {
                var e = t.addedNodes[r];
                mainFunc(e);
              }
            }
          });
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: false,
          characterData: false,
        });
      } catch (error) {
        console.log(error);
      }
    })();
  }
});
// add-on - upsell
document.addEventListener('DOMContentLoaded', () => {
  initializeUpsellHandling();
});

const initializeUpsellHandling = () => {
  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  let selectedAddons = collectCheckedAddons();
  selectedAddons = setupCheckboxListeners(selectedAddons);
  
  form.addEventListener('submit', async (event) => {
    if (selectedAddons.length === 0) {
      return; // ✅ Không ngăn form nếu không có add-on
    }
    
    event.preventDefault();

    try {
      if (selectedAddons.length > 0) {
        await submitAddons(selectedAddons);
      }

      await submitMainProduct(form);
      window.location.href = '/cart';
    } catch (error) {
      console.error("❌ Submit error:", error);
    }
  });
}

// 🟢 1. Lấy các variant ID đang được check ban đầu
const collectCheckedAddons = () => {
  const selected = [];
  const checkboxes = document.querySelectorAll(".gift-box .upsell-checkbox");

  checkboxes.forEach((checkbox) => {
    const variantId = parseInt(checkbox.dataset.variantId);
    if (checkbox.checked && !selected.includes(variantId)) {
      selected.push(variantId);
    }
  });

  return selected;
}

// 🟢 2. Theo dõi checkbox thay đổi để cập nhật selectedAddons
const setupCheckboxListeners = (selectedAddons) => {
  const selected = [...selectedAddons]
  const checkboxes = document.querySelectorAll(".gift-box .upsell-checkbox");

  checkboxes.forEach((checkbox) => {
    const variantId = parseInt(checkbox.dataset.variantId);

    checkbox.addEventListener("change", () => {
      if (checkbox.checked) {
        if (!selected.includes(variantId)) {
          selected.push(variantId);
        }
      } else {
        const index = selected.indexOf(variantId);
        if (index > -1) {
          selected.splice(index, 1);
        }
      }
    });
  });
  return selected;
}

// 🟢 3. Gửi sản phẩm chính
const submitMainProduct = async(form) => {
  const formData = new FormData(form);
  const id = parseInt(formData.get("id"));
  const quantity = parseInt(formData.get("quantity")) || 1;

  const payload = {
    items: [{ id, quantity }],
  };

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify(payload),
  });


  if (!response.ok) throw new Error("Lỗi khi thêm sản phẩm chính");
  const data = await response.json();
  // console.log("✅ Sản phẩm chính đã thêm:", data);
}

// 🟢 4. Gửi sản phẩm add-on
const submitAddons = async(addonIds) => {
  const items = addonIds.map((id) => ({
    id,
    quantity: 1,
  }));

  const response = await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    body: JSON.stringify({ items }),
  });

  if (!response.ok) throw new Error("Lỗi khi thêm sản phẩm add-on");
  const data = await response.json();
  console.log("✅ Add-on đã thêm:", JSON.stringify(data));
}
// end add-on - upsell